import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const preset = definePreset(Aura, {
    semantic: {
        colorScheme: {
            light: {
                formField: {
                    background: '#ffffff',
                    borderColor: 'rgb(232, 232, 232)',
                    hoverBorderColor: 'rgb(232, 232, 232)',
                    focusBorderColor: 'rgb(232, 232, 232)',
                    color: 'rgb(4, 15, 15)',
                    placeholderColor: 'rgba(4, 15, 15, 0.3)',
                    focusRing: {
                        width: '0',
                        style: 'none',
                        color: 'transparent',
                        offset: '0',
                        shadow: 'none',
                    },
                    shadow: 'none',
                },
                overlay: {
                    select: {
                        background: '#ffffff',
                        borderColor: 'rgb(232, 232, 232)',
                        color: 'rgb(4, 15, 15)',
                    },
                },
                list: {
                    option: {
                        focusBackground: 'rgb(222, 253, 243)',
                        selectedBackground: 'rgb(85, 227, 142)',
                        selectedFocusBackground: 'rgb(85, 227, 142)',
                        color: 'rgb(4, 15, 15)',
                        focusColor: 'rgb(26, 161, 118)',
                        selectedColor: 'rgb(4, 15, 15)',
                        selectedFocusColor: 'rgb(4, 15, 15)',
                    },
                },
            },
        },
    },
})

export default {
    theme: {
        preset,
        options: {
            darkModeSelector: 'none',
            cssLayer: false,
        },
    },
}
